import {AutoComplete, DatePicker, Form, Input, InputNumber, Select} from "antd";
import {FormInstance} from "antd/lib/form/Form";
import React, {useContext, useEffect, useRef, useState} from "react";

import type {InputRef} from "antd";
import {FIELD_TYPE, FORMAT_TIME, LOAI_DON_THUOC} from "types/enums";
import {useAppSelector} from "redux/hooks";
import {pharmacyStoreService, catalogService, storeService} from "api";
import InputCode from "components/common/Code/Code";
import {
  convertIosStringToDateDayjs,
  formatDateToString,
  randomId,
  toNumber,
} from "helper/common";
import Notification from "components/common/notification/notification";
import {Rule} from "antd/es/form";
import {validateMaxMin} from "helper/validate";
type EditableRowProps = {
  index: number;
};
const {INPUT, NUMBER, DATE, AUTO_COMPLETE, COMBO_BOX, CURRENCY, CODE} =
  FIELD_TYPE;
export type EditableCellProps = {
  title: React.ReactNode;
  editable?: boolean;
  children: React.ReactNode;
  dataIndex: any;
  record: any;
  selected: boolean;
  options: any;
  name: string;
  index: number;
  type: FIELD_TYPE;
  disabled?: boolean;
  value?: any;
  onChange?: (e) => void;
  onFocus?: () => void;
  onPressEnter?: (e) => void;
  addonAfter?: any;
  rules?: Rule[];
  hidden?: boolean;
  form?: any;
  setTongTien?: any;
  setTongTienHoanTra?: any;
};

export const EditableRow: React.FC<EditableRowProps> = ({index, ...props}) => {
  return (
    <>
      <tr {...props} />
    </>
  );
};

export const EditableCell: React.FC<EditableCellProps> = ({
  title,
  editable,
  children,
  dataIndex,
  record,
  selected,
  options,
  name,
  index,
  type,
  onChange,
  onPressEnter,
  disabled,
  value,
  rules,
  hidden,
  setTongTien,
  setTongTienHoanTra,
  form,
  ...restProps
}) => {
  const [newOptions, setNewOptions] = useState(options);
  const [currentLo, setCurrentLo] = useState(null);
  const [max, setMax] = useState(null);
  const [tiLeUnit, setTiLeUnit] = useState(1);
  const [tonKho, setTonKho] = useState<Number>(0);
  const [currentMedicine, setCurrentMedicine] = useState();
  const [donGia, setDonGia] = useState<any>(0);
  const [allRules, setAllRules] = useState<Rule[]>(rules || []);
  const detailRecord = useAppSelector(
    state => state.medicineStore.detailRecord
  );
  const typePrescription = useAppSelector(
    state => state.medicineStore.typePrescription
  );

  const [listSearchMedicine, setListSearchMedicine] = useState<any[]>([]);
  const khoId = 8;
  const setFieldValue = (dataIndex: string, value: any) => {
    form?.setFieldValue([name, index, dataIndex], value);
  };
  const getFieldValue = (dataIndex: string) => {
    return form?.getFieldValue([name, index, dataIndex]);
  };
  const setSoLuongBan = async () => {
    const detailLo = await getDetailLo(getFieldValue("soLo"), khoId);
    const soLuongKe = record["soLuong"];
    const tonKho = detailLo.tonKho;
    // console.log(tonKho);
    // setMaxQuantitySale(detailLo.tonKho);
    if (soLuongKe > tonKho) {
      setFieldValue("soLuongBan", tonKho);
      // form.setFieldValue("soLuongBan", tonKho);
    } else {
      setFieldValue("soLuongBan", soLuongKe);
    }
    setTongTien();
  };
  useEffect(() => {
    if (record) {
      setMaxOfCell(record);
      setTonKho(record?.tonKho || 0);
      setDonGia(record?.donGia || 0);
      setFieldValue("vat", toNumber(record?.vat));
      setListBaoChe();
      setListDuocChinh();
      if (
        dataIndex == "tenThuoc" &&
        detailRecord?.prescriptionDto?.status == "CB"
      ) {
        setCurrentLoByMedicine(record?.tenThuoc);
      }
    }
    setListUnit();
  }, []);
  const setCurrentLoByMedicine = async tenThuoc => {
    if (tenThuoc) {
      let listLo = await getListLoInStoreByParams();
      if (listLo?.length > 1) {
        const result = listLo?.filter(item => item?.tenThuoc === tenThuoc);
        setCurrentLo(result[0]?.soLo);
        setFieldValue("soLo", result[0]?.soLo);
      } else {
        setCurrentLo(listLo?.[0]?.soLo);
        setFieldValue("soLo", listLo?.[0]?.soLo);
      }
    }
  };
  useEffect(() => {
    if (currentMedicine) {
      setValueByMedicine(currentMedicine);
    }
  }, [currentMedicine]);
  useEffect(() => {
    if (
      (dataIndex == "soLo" ||
        dataIndex == "tenThuoc" ||
        dataIndex == "thuocId") &&
      currentLo
    ) {
      setValueByLo(currentLo, khoId);
    }
  }, [currentLo]);
  useEffect(() => {
    if (dataIndex == "soLuongBan") {
      setMaxQuantitySale();
    }
  }, [typePrescription, detailRecord, record]);
  const setMaxQuantitySale = () => {
    if (
      typePrescription == LOAI_DON_THUOC.DA_TAO &&
      detailRecord?.prescriptionDto?.status != "CB"
    ) {
      setMax(detailRecord?.listPrescriptionSalesDto?.[index]?.soLuongBan);
    }
  };
  const setMaxOfCell = record => {
    if (dataIndex == "vat") {
      setMax(100);
    }
    if (dataIndex == "soLuongHoanTra") {
      setAllRules([
        ...allRules,
        {
          validator: async (_, value) => {
            await validateMaxMin("max", value, record?.soLuongBan);
          },
          message: "Số lượng hoàn trả đã lớn hơn số lượng bán",
        },
      ]);
    }
  };
  const setValueByMedicine = async currentMedicine => {
    // console.log(currentMedicine);
    setFieldValue(
      "thuocId",
      currentMedicine?.id != null ? currentMedicine?.id.toString() : null
    );
    setFieldValue("tenThuoc", currentMedicine?.name);
    setFieldValue("baoCheId", currentMedicine?.baoCheId);
    setFieldValue("duocChinhId", currentMedicine?.duocChinhId);
    setFieldValue("hoatChat", currentMedicine?.hoatChat);
    setFieldValue("donViTinhId", currentMedicine?.donViTinhId);
    setFieldValue("donViBanId", currentMedicine?.donViTinhId);
    setFieldValue("baoQuan", currentMedicine?.baoQuan);

    setCurrentLoByMedicine(currentMedicine?.name);
  };
  const setValueByLo = async (soLo, khoId) => {
    var detailLo = await getDetailLo(soLo, khoId);
    setFieldValue(
      "thuocId",
      detailLo.thuocId != null ? detailLo.thuocId.toString() : null
    );
    setFieldValue("tenThuoc", detailLo?.tenThuoc);
    setFieldValue("tonKho", detailLo?.tonKho);
    setFieldValue("donGia", detailLo?.donGiaXuat);
    setFieldValue("donGiaNhap", detailLo?.donGiaNhap);
    setFieldValue("baoCheId", detailLo?.baoCheId);
    setFieldValue("duocChinhId", detailLo?.duocChinhId);
    setFieldValue("baoQuan", detailLo?.baoQuan);
    setFieldValue("hoatChat", detailLo?.hoatChat);
    setFieldValue("nhomThuoc", detailLo?.nhomThuoc);
    setFieldValue("nuocSanXuat", detailLo?.nuocSanXuat);
    setFieldValue("nhaCungCap", detailLo?.nhaCungCap);
    setFieldValue("donViTinhId", detailLo?.donViTinhId);
    setFieldValue("donViBanId", detailLo?.donViTinhId);
    setFieldValue(
      "ngayHetHan",
      detailLo?.ngayHetHan
        ? convertIosStringToDateDayjs(detailLo.ngayHetHan)
        : null
    );
    setTonKho(detailLo?.tonKho);
    setDonGia(detailLo?.donGiaXuat);
    handleChangeDonViTinh(detailLo?.donViTinhId);
  };
  const handleChangeDonViTinh = async donViTinhId => {
    const thuocId = getFieldValue("thuocId");
    let listUnit: any = null;
    if (thuocId != null) {
      const res = await getListUnitByThuocId(thuocId);
      listUnit = res;
    } else {
      const res = await getListUnit();
      listUnit = res.data;
    }

    const donVi = listUnit.find(e => e.id == donViTinhId);
    setFieldValue("donViBan", donVi?.name);
    const tiLe = donVi?.tiLe ?? 1;
    const phepTinh = donVi?.phepTinh ?? "Nhân";
    const tiLeThuc = phepTinh == "Nhân" ? Number(tiLe) : Number(1 / tiLe);

    setTiLeUnit(tiLeThuc);
  };
  useEffect(() => {
    if (dataIndex == "soLo" || dataIndex == "donViBanId") {
      const soLuongTonMoi = Number(tonKho) * tiLeUnit;
      const donGiaMoi = Number(donGia) / tiLeUnit;

      setFieldValue("tonKho", soLuongTonMoi);
      setFieldValue("donGia", !isNaN(donGiaMoi) ? donGiaMoi : null);
    }
  }, [tiLeUnit, tonKho, donGia]);
  const getListLoInStoreByParams = async () => {
    let params: any = {
      tenThuoc: getFieldValue("tenThuoc"),
      ngayHetHan: formatDateToString(
        getFieldValue("ngayHetHan"),
        FORMAT_TIME.dayFull
      ),
      khoId: khoId,
    };

    try {
      const res = await storeService.getListLoInStoreByParams(params);
      if (res.length == 0) {
        // Notification(
        //   "info",
        //   "Không có lô thuốc nào ở nhà thuốc thỏa mãn các tham số đã chọn"
        // );
      }
      return res;
    } catch (error) {
      return [];
    }
  };
  const getListUnitByThuocId = async id => {
    try {
      const res = await pharmacyStoreService.getListUnitByThuocId(id);
      return res;
    } catch (error) {
      return [];
    }
  };

  const getListUnit = async () => {
    try {
      const res = await catalogService.getListUnit();
      return res;
    } catch (error) {
      return [];
    }
  };
  const setListUnit = async () => {
    if (dataIndex == "donViTinhId" || dataIndex == "donViBanId") {
      const res = await getListUnit();
      const listUnit = res?.data;

      setNewOptions(listUnit.map(e => ({value: e.id, label: e.name})));
    }
  };
  const setListBaoChe = async () => {
    if (dataIndex == "baoCheId") {
      const res = await getListBaoChe();
      const listBaoChe = res;
      setNewOptions(listBaoChe.map(e => ({value: e.id, label: e.name})));
    }
  };
  const setListDuocChinh = async () => {
    if (dataIndex == "duocChinhId") {
      const res = await getListDuocChinh();
      const listDuocChinh = res;
      setNewOptions(
        listDuocChinh.map(e => ({key: randomId(), value: e.id, label: e.name}))
      );
    }
  };
  const getListBaoChe = async () => {
    try {
      const res = await storeService.getListBaoChe();
      return res;
    } catch (error) {
      return [];
    }
  };
  const getListDuocChinh = async () => {
    try {
      const res = await storeService.getListDuocChinh();
      return res;
    } catch (error) {
      return [];
    }
  };
  const getDetailLo = async (soLo, khoId) => {
    try {
      const res = await pharmacyStoreService.getDetailLo(soLo, khoId);
      return res;
    } catch (error) {
      Notification("success", "Đã có lỗi khi lấy thông tin của số lô vừa nhập");
      return null;
    }
  };
  const getDetailMedicineById = async id => {
    try {
      const res = await pharmacyStoreService.getPharmacy(id);
      return res;
    } catch (error) {
      return null;
    }
  };
  const setListMedicineByParams = async () => {
    const params: any = {
      tenThuoc: getFieldValue("tenThuoc"),
      baoCheId: getFieldValue("baoCheId"),
      ngayHetHan: getFieldValue("ngayHetHan"),
      khoId: khoId,
      // hoatChatId: getFieldValue('hoatChatId')
    };
    let listMedicine: any[] = [];

    const res = await storeService.getListMedicineInStoreByParams(params);

    listMedicine = res;
    setListSearchMedicine(res);
    if (dataIndex == "thuocId") {
      setNewOptions(
        listMedicine.map(e => ({key: randomId(), value: e.id, label: e.id}))
      );
    }
    if (dataIndex == "tenThuoc") {
      setNewOptions(
        listMedicine.map(e => ({
          key: randomId(),
          value: e.name,
          label: e?.name,
        }))
      );
    }
  };
  const setTongTienThuoc = () => {
    const soLuongBan = toNumber(getFieldValue("soLuongBan"));
    const donGia = toNumber(getFieldValue("donGia"));
    const vat = toNumber(getFieldValue("vat"));
    const tongTien = (soLuongBan * donGia * (100 + vat)) / 100;
    setFieldValue("tongTien", toNumber(tongTien));
    setTongTien(getTongTienDon());
    console.log(toNumber(tongTien));
  };
  const setTongTienThuocHoanTra = () => {
    const soLuongBanHoanTra = toNumber(getFieldValue("soLuongHoanTra"));
    const donGia = toNumber(getFieldValue("donGia"));
    const vat = toNumber(getFieldValue("vat"));
    const tongTien = (soLuongBanHoanTra * donGia * (100 + vat)) / 100;
    setFieldValue("tongTienHoanTra", toNumber(tongTien));
    setTongTienHoanTra(getTongTienHoanTra());
  };
  const getTongTienDon = () => {
    const formTable = form.getFieldValue(name) || [];
    let tongGiaTriDon = 0;
    formTable.forEach(e => {
      tongGiaTriDon += toNumber(e?.tongTien);
    });
    return tongGiaTriDon;
  };
  const getTongTienHoanTra = () => {
    const formTable = form.getFieldValue(name) || [];
    let tongGiaTriDon = 0;
    formTable.forEach(e => {
      tongGiaTriDon += toNumber(e?.tongTienHoanTra);
    });
    return tongGiaTriDon;
  };

  let childNode = children;

  if (type == INPUT) {
    childNode = (
      <Form.Item
        name={[name, index, dataIndex]}
        initialValue={getFieldValue(dataIndex) ?? null}
        rules={allRules}
        style={{display: hidden ? "none" : "default"}}
      >
        <Input
          disabled={disabled}
          onChange={async e => {
            if (dataIndex == "thuocId") {
              alert(e.target.value);
            }
          }}
        ></Input>
      </Form.Item>
    );
  }
  if (type == DATE) {
    childNode = (
      <Form.Item name={[name, index, dataIndex]}>
        <DatePicker
          disabled={disabled}
          onChange={() => {}}
          format={FORMAT_TIME.dayFull as string}
          placeholder={!disabled ? "Chọn ngày" : null}
        ></DatePicker>
      </Form.Item>
    );
  }
  if (type == NUMBER) {
    childNode = (
      <Form.Item
        name={[name, index, dataIndex]}
        initialValue={getFieldValue(dataIndex) ?? null}
        rules={allRules}
      >
        <InputNumber
          disabled={disabled}
          onClick={() => {
            if (dataIndex == "soLuongBan") {
              setMax(getFieldValue("tonKho"));
            }
          }}
          onChange={e => {
            if (dataIndex == "soLuongBan" || dataIndex == "vat") {
              setTongTienThuoc();
            }
            if (dataIndex == "soLuongHoanTra") {
              setTongTienThuocHoanTra();
            }
          }}
          max={max}
          controls={false}
          {...restProps}
        ></InputNumber>
      </Form.Item>
    );
  }
  if (type == AUTO_COMPLETE) {
    childNode = (
      <Form.Item
        name={[name, index, dataIndex]}
        initialValue={getFieldValue(dataIndex) ?? null}
        rules={allRules}
      >
        <AutoComplete
          showSearch
          allowClear
          notFoundContent={null}
          value={value}
          defaultActiveFirstOption={false}
          filterOption={(inputValue, option) =>
            option?.label
              ?.toString()
              .toUpperCase()
              .indexOf(inputValue.toUpperCase()) !== -1
          }
          options={newOptions}
          disabled={disabled}
          {...restProps}
          onClear={() => {
            if (dataIndex == "soLo") {
              setFieldValue("tonKho", null);
              setFieldValue("donGia", null);
              setFieldValue("baoCheId", null);
              setFieldValue("duocChinhId", null);
              setFieldValue("baoQuan", null);
              setFieldValue("vat", null);
              setFieldValue("hoatChat", null);
              setFieldValue("nhomThuoc", null);
              setFieldValue("nuocSanXuat", null);
              setFieldValue("nhaCungCap", null);
              setFieldValue("donViTinhId", null);
              setFieldValue("donViBanId", null);
              setFieldValue("donViBan", null);
              setFieldValue("ngayHetHan", null);
            }
          }}
          onClick={async () => {
            if (dataIndex == "soLo") {
              const listLo = await getListLoInStoreByParams();
              setNewOptions(listLo.map(e => ({value: e.soLo, label: e.soLo})));
            }
            if (dataIndex == "thuocId" || dataIndex == "tenThuoc") {
              setListMedicineByParams();
            }
          }}
          onChange={async e => {
            if (dataIndex == "soLo") {
              setCurrentLo(e);
            }
            if (dataIndex == "thuocId") {
              const detailMedicine = await getDetailMedicineById(e);
              setCurrentMedicine(detailMedicine);
              setCurrentLo(null);
              setFieldValue("soLo", null);
              setFieldValue("tenThuoc", null);
              setFieldValue("hanSuDung", null);
              setFieldValue("ngaySanXuat", null);
              setFieldValue("baoCheId", null);
              setFieldValue("duocChinhId", null);
              setFieldValue("ngayHetHan", null);
              setFieldValue("donGia", null);
              setFieldValue("donGiaXuat", null);
              setFieldValue("soLuongNhap", null);
              setFieldValue("tonKho", null);
              setFieldValue("vat", null);
              setFieldValue("hoatChat", null);
              setFieldValue("nuocSanXuat", null);
              setFieldValue("nhaCungCap", null);
              setFieldValue("donViBan", null);
              setFieldValue("donViBanId", null);
            }
            if (dataIndex == "tenThuoc") {
              const selectedThuocId = listSearchMedicine.find(
                medicine => medicine.name == e
              )?.id;
              const detailMedicine = await getDetailMedicineById(
                selectedThuocId
              );

              setCurrentMedicine(detailMedicine);
              setCurrentLo(null);
              setFieldValue("soLo", null);
              setFieldValue("thuocId", null);
              setFieldValue("ngayHetHan", null);
              setFieldValue("tonKho", null);
              setFieldValue("baoCheId", null);
              setFieldValue("donGia", null);
              setFieldValue("vat", null);
              setFieldValue("hoatChat", null);
              setFieldValue("nuocSanXuat", null);
              setFieldValue("nhaCungCap", null);
              setFieldValue("donViBan", null);
              setFieldValue("donViBanId", null);
            }

            // lay list so lo
          }}
        ></AutoComplete>
      </Form.Item>
    );
  }
  if (type == COMBO_BOX) {
    childNode = (
      <Form.Item
        style={{margin: 0}}
        name={[name, index, dataIndex]}
        initialValue={getFieldValue(dataIndex) ?? null}
      >
        <Select
          showSearch
          style={{
            width: "100%",
          }}
          filterOption={(input, option) =>
            (option?.label.toString().toLowerCase() ?? "").includes(
              input.toLowerCase()
            )
          }
          placeholder={"Chọn"}
          options={newOptions}
          disabled={disabled}
          allowClear={true}
          onClick={async e => {
            if (dataIndex == "donViTinhId" || dataIndex == "donViBanId") {
              const tenThuoc = getFieldValue("tenThuoc");
              const thuocId = getFieldValue("thuocId");
              let listUnit: any = null;
              var detailLo = await getDetailLo(getFieldValue("soLo"), khoId);

              setTonKho(detailLo?.tonKho ?? 0);
              setDonGia(detailLo?.donGiaXuat ?? 0);
              if (thuocId) {
                const res = await getListUnitByThuocId(thuocId);
                listUnit = res;
              } else {
                const res = await getListUnit();
                listUnit = res.data;
              }
              setNewOptions(listUnit.map(e => ({value: e.id, label: e.name})));
            }
          }}
          onChange={async e => {
            if (dataIndex == "donViTinhId" || dataIndex == "donViBanId") {
              handleChangeDonViTinh(e);
            }
          }}
          {...restProps}
        />
      </Form.Item>
    );
  }
  if (type == CURRENCY) {
    childNode = (
      <Form.Item
        name={[name, index, dataIndex]}
        initialValue={getFieldValue(dataIndex) ?? null}
      >
        <InputNumber
          disabled={disabled}
          defaultValue={value}
          formatter={value =>
            `${Math.round(value)?.toString()}`.replace(
              /\B(?=(\d{3})+(?!\d))/g,
              ","
            )
          }
          parser={value => value!.replace(/\$\s?|(,*)/g, "")}
          onChange={e => {
            if (dataIndex == "donGia") {
              setTongTienThuoc();
            }
          }}
          placeholder={!disabled ? "Nhập" : null}
          addonAfter="VNĐ"
          stringMode
          controls={false}
          min={0}
          {...restProps}
        />
      </Form.Item>
    );
  }

  return <td {...restProps}>{childNode}</td>;
};
